export function flagGroupComplete(item, attributes) {
    if ("groupId" in item) {
        return (item.isComplete = item.items.every((childItem) => flagGroupComplete(childItem, attributes)));
    }
    if ("attributeId" in item) {
        return (item.isComplete = attributes.some((attribute) => attribute.id === item.attributeId && attribute.isComplete));
    }
    return true;
}
//# sourceMappingURL=flagGroupComplete.js.map